import React from "react";

function BS4_MediaObjects() {
  return (
    <div>
      <h1>BS4_MediaObjects Component</h1>
      <p>This is the BS4_MediaObjects tutorial page content.</p>
    </div>
  );
}

export default BS4_MediaObjects;
